import useAuth from '@sdk/authentication/useAuth';

import useIsTimesheetConsentFlowFeatureFlagEnabled from '@web/automatedBreaks/hooks/useIsTimesheetConsentFlowFeatureFlagEnabled';

const useRequireAssigneeConsent = (): boolean => {
  const { currentUser } = useAuth();
  const isConsentFlowFeatureFlagEnabled = useIsTimesheetConsentFlowFeatureFlagEnabled();

  return isConsentFlowFeatureFlagEnabled && currentUser.isManager;
};

export default useRequireAssigneeConsent;
